import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export const COLOR_SCHEME_PREFERENCES = {
  light: 'light',
  dark: 'dark',
  system: 'system',
} as const

export type ColorSchemePreference =
  (typeof COLOR_SCHEME_PREFERENCES)[keyof typeof COLOR_SCHEME_PREFERENCES]

export const COLOR_SCHEME_STORAGE_KEY = 'core-color-scheme'

interface ColorSchemeState {
  preference: ColorSchemePreference
  isLightForced: boolean
  setPreference: (preference: ColorSchemePreference) => void
  setLightForced: (isLightForced: boolean) => void
}

export const useColorSchemeStore = create<ColorSchemeState>()(
  persist(
    (set) => ({
      preference: COLOR_SCHEME_PREFERENCES.light,
      isLightForced: false,
      setPreference: (preference) => set({ preference }),
      setLightForced: (isLightForced) => set({ isLightForced }),
    }),
    {
      name: COLOR_SCHEME_STORAGE_KEY,
      partialize: (state) => ({ preference: state.preference }),
    }
  )
)
